import { render, staticRenderFns } from "./BaseDataTableSearchPopover.vue?vue&type=template&id=0277131d&scoped=true"
import script from "./BaseDataTableSearchPopover.vue?vue&type=script&lang=js"
export * from "./BaseDataTableSearchPopover.vue?vue&type=script&lang=js"
import style0 from "./BaseDataTableSearchPopover.vue?vue&type=style&index=0&id=0277131d&prod&scoped=true&lang=css"
import style1 from "./BaseDataTableSearchPopover.vue?vue&type=style&index=1&id=0277131d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0277131d",
  null
  
)

export default component.exports